import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { DeleteAdministratorModel } from 'src/app/admin-panel/models/system-profiles/delete-administrator.model';
import { AdministratorService } from 'src/app/admin-panel/services/system-profiles/administrator-service';

@Component({
  selector: 'app-delete-administrator',
  templateUrl: './delete-administrator.component.html',
  styleUrls: ['./delete-administrator.component.scss']
})
export class DeleteAdministratorComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public deleteAdministratorModel : DeleteAdministratorModel;
  public spinner: boolean=false
  //#endregion
  //#region Constructor
  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private administratorService : AdministratorService
  ) {
    this.deleteAdministratorModel = new DeleteAdministratorModel();
    if (this.config.data != undefined && this.config.data.id) {
      this.deleteAdministratorModel.adminId = this.config.data.id
    }
  }

  ngOnInit(): void {
  }
  //#endregion
  //#region Public Methods
  deleteUser() {
    this.spinner = true
    this.administratorService.deleteAdmin(this.deleteAdministratorModel)
    .pipe(takeUntil(this.unsubscribe))
    .subscribe({
      next: (response) => {  
        this.spinner = false      
        this.ref.close(true)
      },
      error: errorResponse => {
        this.spinner = false 
      }
    });
  }
  cancel() {
    this.ref.close(false)
  }
  //#endregion
  //#Private Methods
  //#endregion
}
